import { Suspense, useContext, useEffect, useState } from 'react';
import { Await, Link, useLoaderData, useNavigate } from 'react-router-dom';
import PaginatedCards from '../../components/paginatedCards/PaginatedCards';
import Loader from '../../components/loader/Loader';
import './profilePage.scss';
import apiRequest from '../../lib/apiRequest';
import { AuthContext } from '../../context/AuthContext';

function ProfilePage() {
  const data = useLoaderData();
  const { updateUser, currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [locationData, setLocationData] = useState({
    country: '',
    region: '',
    city: '',
  });
  const [locationError, setLocationError] = useState(null); // Для ошибок геолокации

  const handleLogout = async () => {
    try {
      await apiRequest.post('/auth/logout');
      updateUser(null);
      navigate('/');
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // Проверка sessionStorage на наличие данных о местоположении
    const savedCountry = sessionStorage.getItem('selectedCountry')
      ? JSON.parse(sessionStorage.getItem('selectedCountry')).label
      : '';
    const savedState = sessionStorage.getItem('selectedState')
      ? JSON.parse(sessionStorage.getItem('selectedState')).label
      : '';
    const savedCity = sessionStorage.getItem('selectedCity')
      ? JSON.parse(sessionStorage.getItem('selectedCity')).label
      : '';

    if (savedCountry || savedState || savedCity) {
      // Если данные о местоположении найдены, обновляем состояние
      setLocationData({
        country: savedCountry,
        region: savedState,
        city: savedCity,
      });
    } else if (navigator.geolocation) {
      // Если данных в sessionStorage нет, запрашиваем геолокацию
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`)
            .then((response) => response.json())
            .then((data) => {
              const country = data.address.country || 'Unknown';
              const region = data.address.state || 'Unknown';
              const city = data.address.city || data.address.town || 'Unknown';

              // Обновляем данные местоположения
              setLocationData({ country, region, city });

              // Сохраняем данные в sessionStorage
              sessionStorage.setItem('selectedCountry', JSON.stringify({ label: country }));
              sessionStorage.setItem('selectedState', JSON.stringify({ label: region }));
              sessionStorage.setItem('selectedCity', JSON.stringify({ label: city }));
            })
            .catch((error) => setLocationError('Unable to fetch location details.'));
        },
        (error) => {
          setLocationError('Geolocation permission denied.');
        }
      );
    } else {
      setLocationError('Geolocation is not supported by your browser.');
    }
  }, []);

  return (
    <div className="profilePage">
      <div className="details">
        <div className="wrapper">
  <Suspense fallback={<Loader />}>
    {data?.postResponse ? (
      <Await resolve={data.postResponse} errorElement={<p>Error loading ads!</p>}>
        {(postResponse) => <PaginatedCards posts={postResponse.data.userPosts} />}
      </Await>
    ) : (
      <p>No posts available.</p>
    )}
  </Suspense>
</div>
      </div>
      <div className="chatContainer">
        <div className="info">
          {!currentUser?.user ? (
            <p>Loading user data...</p>
          ) : (
            <>
              <span>
                <img className="ava" src={currentUser?.user?.avatar?.url || "noavatar.jpg"} alt="Avatar" />
                <b>{currentUser?.user?.username}</b>
              </span>
              <span>
                <img className="icons" src="/location.png" alt="Location" />
                {locationData.country || locationData.region || locationData.city ? (
                  <p>
                  {locationData.country}
                  {(locationData.region || locationData.city) && `, ${locationData.region || ''}${locationData.city ? `, ${locationData.city}` : ''}`}
                  </p>
                ) : locationError ? (
                  <p>{locationError}</p>
                ) : (
                  <p>Fetching location...</p>
                )}
              </span>
              <span>
                <img className="icons" src="/mail.png" alt="Email" /> {currentUser?.user?.email || "No email"}
              </span>
              <span>
                <img className="icons" src="/phone.png" alt="Phone" /> {currentUser?.user?.phone || "No phone number"}
              </span>
              <div className="buttons">
                <button onClick={handleLogout}>Logout</button>
                <Link to="/profile/update">
                  <button>Update Profile</button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
